import React, { SetStateAction } from 'react';
import IconCloseSvg from './icon/IconCloseSvg';
import { trackLoginStart } from '../../../../../hooks/useLoginTracking/useLoginTracking';
import { useCustomerContext } from '@jbhi-fi/components/src/context/CustomerContextProvider';
import { styles } from './LogInTooltip.css';

export type LogInTooltipProps = {
  productCartData?: any;
  sku: number;
  isDigital?: boolean;
  priceTagWidth?: number;
  tooltipVisible?: boolean;
  displayLoginModal?: boolean;
  tooltipMessage?: string;
  variantId: number;
  className?: string;
  setDisplayLoginModal?: React.Dispatch<SetStateAction<boolean>>;
  setToolTipVisible?: React.Dispatch<SetStateAction<boolean>>;
};

const LogInTooltip = ({
  sku,
  isDigital,
  priceTagWidth,
  tooltipVisible,
  displayLoginModal,
  tooltipMessage,
  productCartData,
  variantId,
  setToolTipVisible,
}: LogInTooltipProps): JSX.Element | null => {
  const objectId: number = productCartData?.Id;
  const { handleUpdateWishlist } = useCustomerContext();

  // send gtm event and navigate to login page
  const loginFunction = (): void => {
    trackLoginStart({ baseEventData: { eventCategory: 'wishlist' } });
    handleUpdateWishlist({
      actionType: 'addItem',
      sku: `${sku}`,
      variantId,
      notLoggedInAction: 'login',
    });
  };

  // send gtm event and navigate to create account page
  const createAccountFunction = (): void => {
    trackLoginStart({ baseEventData: { eventCategory: 'wishlist' }, isCreate: true });
    handleUpdateWishlist({
      actionType: 'addItem',
      sku: `${sku}`,
      variantId,
      notLoggedInAction: 'createAccount',
    });
  };

  // Close tooltip and send gtm event
  const closeToolTipFunction = async (): Promise<void> => {
    if (setToolTipVisible) setToolTipVisible(false);
    try {
      await window.dataLayer.push({
        event: 'sendEvent',
        eventCategory: 'Account',
        eventAction: 'Close pop up',
        eventLabel: 'wishlist',
      });
    } catch (error) {
      console.error('Error submitting dataLayer', error);
    }
  };

  // Render tooltip!
  return displayLoginModal ? (
    <div
      className={`tool-tip ${styles.toolTip({ tooltipVisible })}`}
      data-testid="pdp-wishlist-tooltip"
      data-product-sku={sku}
      data-product-objectid={objectId}
      style={{ width: priceTagWidth ? `${priceTagWidth}px` : 'auto' }}
    >
      <button className={styles.closeButton} onClick={() => closeToolTipFunction()}>
        <IconCloseSvg />
      </button>
      <div data-testid="pdp-wishlist-tooltip-message" className={styles.wishlistWords({ displayLoginModal })}>
        {tooltipMessage}
      </div>
      <button
        data-testid="pdp-wishlist-tooltip-create-account-button"
        className={styles.createAccount}
        onClick={() => createAccountFunction()}
      >
        Create account
      </button>
      <button data-testid="pdp-wishlist-tooltip-login-button" className={styles.login} onClick={() => loginFunction()}>
        Login
      </button>
    </div>
  ) : null;
};

export default LogInTooltip;
